(() => {
  const KEY = 'valvin_vat_display';
  const DEFAULT_MODE = 'ex';
  const validMode = (mode) => mode === 'ex' || mode === 'inc';
  const getMode = () => {
    try { return validMode(window.localStorage.getItem(KEY)) ? window.localStorage.getItem(KEY) : DEFAULT_MODE; } catch (error) { return DEFAULT_MODE; }
  };
  const setMode = (mode) => {
    const nextMode = validMode(mode) ? mode : DEFAULT_MODE;
    try { window.localStorage.setItem(KEY, nextMode); } catch (error) {}
    apply(nextMode);
    document.dispatchEvent(new CustomEvent('valvin:vat-mode-change', { detail: { mode: nextMode } }));
  };
  const forEachMatch = (root, selector, callback) => {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) callback(root);
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    root.querySelectorAll(selector).forEach(callback);
  };
  const apply = (mode = getMode(), root = document) => {
    forEachMatch(root, '[data-valvin-price]', (price) => {
      const value = price.querySelector('.valvin-vat-price__value');
      const label = price.querySelector('.valvin-vat-price__label');
      if (!value || !label) return;
      value.textContent = mode === 'ex' ? price.dataset.priceEx : price.dataset.priceInc;
      label.textContent = mode === 'ex' ? 'ex VAT' : 'inc VAT';
      price.dataset.vatMode = mode;
    });
    forEachMatch(root, '[data-valvin-vat-toggle]', (toggle) => {
      toggle.querySelectorAll('[data-vat-mode]').forEach((button) => {
        const selected = button.dataset.vatMode === mode;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-selected', selected);
      });
      toggle.dataset.vatMode = mode;
    });
  };
  const boot = () => {
    if (window.__valvinVatToggleBooted) return;
    window.__valvinVatToggleBooted = true;
    apply();
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-vat-mode]');
      if (button) setMode(button.dataset.vatMode);
    });
    const observer = new MutationObserver((records) => {
      const mode = getMode();
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) apply(mode, node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
